<template>
  <div>
    <div v-for="i in contacts" :key="i.name">
      <h2 name="contactName" class="title is-4">{{ i.name }}</h2>
      <p class="subtitle is-6 has-text-weight-normal mb-6">
        {{ i.address }}, {{ i.city }}, {{ i.zip }} - {{ i.country }}
        <br />
        {{ i.phone }}, {{ i.email }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotelInfo',
  props: {
    contacts: Array,
  },
}
</script>

<style scoped lang="scss">
.subtitle {
  margin-bottom: 1.25em;
}
</style>
